module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(_vm.dismissCountDown) ? _c('b-alert', {
    key: true,
    attrs: {
      "show": _vm.dismissCountDown,
      "dismissible": "",
      "variant": _vm.type
    },
    on: {
      "dismissed": function($event) {
        _vm.dismissCountDown = 0
      },
      "dismiss-count-down": _vm.countDownChanged
    }
  }, [_vm._v("\n\t\t" + _vm._s(_vm.message) + "\n\t")]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-517c07d9"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/elements/FlashMessages/FlashMessagesItem.vue
// module id = 1309
// module chunks = 1